import React, {useContext, useEffect, useState} from 'react';
import OfflineResources from "../resources/OfflineResources";
import ResponsiveRow from "../common/ResponsiveRow";
import {UserContext} from "../common/UserContext";

const DownloadResources = ()=>{

    const params = new URLSearchParams(window.location.search),
        [hideResourcesTitle, setHideResourcesTitle] = useState(true),
        {user} = useContext(UserContext);

    useEffect(()=>{
        if(params.get('hideResourcesTitle') == 'true') {
            setHideResourcesTitle(true);
        } else {
            setHideResourcesTitle(false);
        }
    },[shortcut, window.location.search]);




   return (
       <>
           {!hideResourcesTitle &&
           <ResponsiveRow items={[<h2>{user.syllabusName}</h2>]}/>}
           <ResponsiveRow
                items={[<OfflineResources forceHideTitle={true} collapseDescription={'textbook'} heading={'Textbook resources'} resourcesUrl={'/web/ui/resource/textbookResources'}/>,
                        <OfflineResources forceHideTitle={true} collapseDescription={'document'} heading={'Document resources'} resourcesUrl={'/web/ui/resource/documentResources'}/>]}
           />
       </>)

}

export default DownloadResources;